import axios from "axios";
import VueAxios from "vue-axios";
const baseURL = "https://chicago.mastermindsports.com/"; //Data Base URL
axios.defaults.baseURL = baseURL;

export { VueAxios, axios };
